import {DistanceType, SpellDistance} from '../../generated/types';
import {wordByCount} from '../utils';

/** Расстояние: «120 футов», «1 миля» */
export function toSpellDistance(distance: SpellDistance) {
	switch (distance.type) {
		case DistanceType.Feet:
		case DistanceType.Miles:
			return wordByCount(
				distance.amount!,
				distance.type === DistanceType.Feet ? ['фут', 'фута', 'футов'] : ['миля', 'мили', 'миль'],
				true,
			);
	}
}
